"use strict";

exports.__esModule = true;
exports.ChangeOperatorActionFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _Selector = require("../../Core/Selector");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Controls for ChangeOperatorAction
 */
var ChangeOperatorActionFields = exports.ChangeOperatorActionFields = function ChangeOperatorActionFields(props) {
  var items = [{
    name: "FreeText",
    label: "Free Text"
  }, {
    name: "UserList",
    label: "User List"
  }];
  var item = items.find(function (item) {
    return item.name === props.config.changeOperatorType;
  });
  return /*#__PURE__*/_react["default"].createElement(_Selector.Selector, {
    items: items,
    getKey: function getKey(input) {
      return input.name;
    },
    renderItemText: function renderItemText(input) {
      return input.label;
    },
    selected: item ? [item] : [items[1]],
    onSelect: function onSelect(input) {
      props.onChange(Object.assign({}, props.config, {
        changeOperatorType: input[0].name
      }));
    },
    multiple: false
  });
};